// Implements: F-SHR-009, F-UIX-014
/**
 * `/sharing` — the links the person created, across mockups (UX-08).
 *
 * The page only composes: the listing, the revoke and the edit live in the
 * `sharing` module's `SharingPanelContainer` (F-UIX-009). It sits behind
 * `RequireSession` like every route but `/login`.
 */

import type { ReactElement } from "react";

import { SharingPanelContainer } from "../../modules/sharing/containers/SharingPanelContainer";
import { useTranslation } from "../../shared/i18n";
import { PageHeader } from "../../shared/ui/molecules/PageHeader";

export function SharingPage(): ReactElement {
  const { t } = useTranslation();
  return (
    <section>
      <PageHeader title={t("sharing.panel.title")} subtitle={t("sharing.panel.subtitle")} />
      <SharingPanelContainer />
    </section>
  );
}
